<template>
  <div class="day">
    <div class="cal-header">
      <span
        class="header-content date"
        @click="$emit('setView', '/month', $store.state.thisDate, null)"> {{ $store.state.thisDate | moment('YY/MM/DD(ddd)') }}
        <span class="vertical-divider" />
      </span>
      <span class="header-content feel">気分</span>
      <span class="header-content note">特記事項／相談事</span>
      <span class="header-content actual">今日の実績</span>
      <span class="header-content summary">総括</span>
      <span class="header-content total">勤務時間</span>
    </div>
    <div class="horizontal-divider" />
    <div
      v-for="(user,index) in users"
      :key="index"
      class="user-data"
      @click="$emit('showForm', user.id, $store.state.thisDate.format('YYYY-MM-DD'))">
      <span
        class="main-content name"
        @click.stop="$emit('setView', '/user', $store.state.thisDate, user.id)">
        {{ user.name.last + user.name.first }}
        <span class="vertical-divider" />
      </span>
      <span class="main-content feel">
        <i
          v-if="$store.state.diaries.data[user.id][$store.state.thisDate.format('YYYY-MM-DD')]"
          :class="['material-icons-outlined', diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].feel]">{{ diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].feel }}</i>
        <i
          v-else
          class="material-icons-outlined nothing">block</i>
      </span>
      <span class="main-content note">
        <span v-if="diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')]">{{ diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].note.trim() }}</span>
      </span>
      <span class="main-content actual">
        <span v-if="diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')]">{{ diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].actual.trim() }}</span>
        <span
          v-if="!diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')]"
          class="nothing">投稿されていません</span>
      </span>
      <span class="main-content summary">
        <span v-if="diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')]">{{ diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].summary.trim() }}</span>
      </span>
      <span class="main-content total">
        <span
          v-if="diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')]"
          :class="{warning: diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].time >= 10}">{{ diaries[user.id][$store.state.thisDate.format('YYYY-MM-DD')].displayTime }}</span>
        <span
          v-else
        >0h</span>
      </span>
    </div>
    <div
      v-if="!$store.state.isLoading"
      class="cal-footer">
      <img
        class="logo"
        src="@/assets/img/logo.jpg">
    </div>
  </div>
</template>

<script>
import Moment from 'moment'

export default {
  filters: {
    /**
     * HTML部で使うMomentのフォーマット
     * @param {Moment} value 変換される日付
     * @param {String} format フォーマットの書式
     * @returns {String} フォーマットされた後の日付
     */
    moment (value, format) {
      return Moment(value).format(format)
    }
  },
  computed: {
    /**
     * ユーザーの名前、IDを格納
     * @returns {Array}
     *   <変数名>   <データ型>     <例>        <説明>
     *  id         : String : 'Zjia3wr9ur' : ユーザーID
     *  priority   : Number : 1            : ユーザーの表示順(昇順)
     *  name.last  : String : '佐藤'       : ユーザーの姓
     *  name.first : String : '太郎'       : ユーザーの名
     */
    users () {
      return this.$store.state.selectedUsers.reduce((users, user) => {
        let targetUser = this.$store.state.users.data.find(u => u.id === user.id)
        if (targetUser.isDisplay && targetUser.isActive) {
          users.push({
            id: user.id,
            priority: user.priority,
            name: {
              last: targetUser.name.last,
              first: targetUser.name.first
            }
          })
        }
        return users;
      }, []);
    },
    /**
     * ユーザーIDとした日報情報
     * @returns {Object}
     *  <変数名>     <データ型>     <例>         <説明>
     *  date        : String : '2020-07-21' : 投稿された日付[YYYY-MM-DD]
     *  time        : Number : '8'          : 勤務時間
     *  displayTime : String : '8h20m'      : 勤務時間（表示用）
     *  feel        : String : 'mood'       : 今日の気分(5段階)
     *  actual      : String : '...'        : 今日の実績
     *  summary     : String : '...'        : 総括
     *  note        : String : '...'        : 特記事項
     *  plan        : String : '...'        : 次営業日の予定
     *  event       : String : '...'        : 直近の予定
     */
    diaries () { return this.$store.state.diaries.data }
  },
}
</script>

<style scoped>
.day {
  width: auto;
  height: calc(100% - 45px);
  user-select: none;
  background:#f6f8f7;
  overflow-y: scroll;
  overflow-x: auto;
}
.cal-header {
  width: 100%;
  min-width: 962px;
  height: 45px;
  position: sticky;
  top: 0px;
  background: #fff;
  display: flex;
  z-index: 2;
}
.cal-header .header-content {
  text-align: center;
  font-size: 0.7em;
  color: #828282;
  border-right: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cal-header .date {
  width: 90px;
  min-width: 90px;
  font-size: 0.8em;
  position: sticky;
  left: 0px;
  background: #fff;
  color: #275e7d;
  font-weight: bold;
  cursor: pointer;
  z-index: 1;
}
.cal-header .date:hover {
  font-weight: bold;
}
.cal-header .feel {
  width: 55px;
  min-width: 55px;
}
.cal-header .note {
  width: 33%;
  padding: 5px 5px 5px;
}
.cal-header .actual {
  width: 33%;
  padding: 5px 5px 5px;
}
.cal-header .summary {
  width: 33%;
  padding: 5px 5px 5px;
}
.cal-header .total {
  width: 55px;
  min-width: 55px;
  border-right: 0;
}
.horizontal-divider {
  position: sticky;
  top: 45px;
  height: 4px;
  min-width: 961px;
  background: #fff;
  border: 1px solid #e5e5e5;
  border-left: 0;
  border-right: 0;
  padding: 0 0 0 1px;
  z-index: 2;
}
.vertical-divider {
  position: sticky;
  left: 85px;
  width: 4px;
  min-width: 4px;
  height: 100%;
  background: #fff;
  border-left: 1px solid #e5e5e5;
  padding: 0 1px 0 0px;
  z-index: 2;
}
.user-data {
  width: 100%;
  min-width: 962px;
  min-height: 55px;
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
  color: #333;
}
.user-data:nth-child(even) {
  background: #f9f9f9;
}
.user-data:hover {
  background: #eee;
}
.main-content {
  border-right: 1px solid #e5e5e5;
}
.user-data .name {
  width: 90px;
  min-width: 90px;
  border-right: 1px solid #e5e5e5;
  font-size: 0.7em;
  position: sticky;
  left: 0px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.user-data:nth-child(odd) .name {
  background: #fff;
}
.user-data:nth-child(even) .name {
  background: #f9f9f9;
}
.user-data .name:hover {
  font-weight: bold;
}
.user-data .feel {
  width: 55px;
  min-width: 55px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-data .nothing {
  color: #828282;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-data .note {
  width: 33%;
  font-size: 0.7em;
  padding: 5px 5px 5px;
  white-space: pre-wrap;
}
.user-data .actual {
  width: 33%;
  font-size: 0.7em;
  padding: 5px 5px 5px;
  white-space: pre-wrap;
}
.user-data .summary {
  width: 33%;
  font-size: 0.7em;
  padding: 5px 5px 5px;
  white-space: pre-wrap;
}
.user-data .total {
  width: 55px;
  min-width: 55px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0;
}
.user-data .warning {
  color: #f44336;
}
.cal-footer {
  position: relative;
  height: 60px;
}
.logo {
  width: 150px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}
/* マテリアルアイコン */
.material-icons-outlined {
  font-size: 1.6em;
}
.sentiment_very_satisfied {
  color: #009688;
  opacity: 0.6;
}
.mood {
  color: #498205;
  opacity: 0.6;
}
.sentiment_satisfied {
  color: #0e7bc6;
  opacity: 0.6;
}
.sentiment_dissatisfied {
  color: #744da9;
  opacity: 0.6;
}
.sentiment_very_dissatisfied {
  color: #f44336;
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/Day.vue